export const SET_CONTROL_PANEL = "setControlPanel";
export const CLEAR_CONTROL_PANEL = "clearControlPanel";
export const SET_REPORT = "setReport";
export const CLEAR_REPORT = "clearReport";
export const SET_REPORT_RANGE = "setReportRange";
export const CLEAR_REPORT_RANGE = "clearReportRange";
export const SET_BILLING_CYCLE = "setBillingCycle";
export const SET_CONTRACTED_CREDITS = "setContractedCredits";
export const SET_CONTRACT_EXPIRATION = "setContractExpiration";
export const SET_DUE_DATE = "setDueDate";
export const SET_RESPONSIBLE = "setResponsible";
export const SET_ACTIVATE = "setActivate";
export const SET_REASON = "setReason";
